import React, { useMemo, useState } from "react";
import { Card, CardBody, CardTitle, Form, FormGroup, Label } from "reactstrap";
import FootprintInputRadio from "../../../Components/utils/FootprintInputRadio";
import FootprintInputText from "../../../Components/utils/FootprintInputText";
import FootprintInputButton from "../../../Components/utils/FootprintInputButton";

import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import {
  activeChildDetail,
  appConstants,
  mobileAtom,
} from "../../../AtomStore/store";

import { useNavigate } from "react-router-dom";
import { submitIssue } from "../../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { StyledCardHeader } from "./styles";

const RaiseTicket = () => {
  const { useMutationWrapper } = useRequestProcessor();

  const [issue, SetIssue] = useState();
  const [description, setDescription] = useState();
  const [otherRemark, setOtherRemark] = useState();
  const [activeChild] = useAtom(activeChildDetail);
  const [error, setError] = useState();

  const navigate = useNavigate();
  const [constants] = useAtom(appConstants);

  useMemo(() => {
    console.log(
      "[Raise Ticket] Initializing Raise a Ticket form for child:",
      activeChild?.id
    );
  }, [activeChild]);

  const raiseIssue = useMutationWrapper(
    "raiseIssue",
    () => {
      console.log("[Raise Ticket] Calling API: /parentapp/createTicket ", {
        issue: issue,
        description: description,
        child_id: activeChild?.id,
      });

      return submitIssue(issue, description, navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Raise Ticket] Raise Ticket request response:", data);
      },
    }
  );

  const validate = () => {
    if (issue === undefined) {
      setError("Please Select Issue");

      return false;
    } else if (issue === "Others" && otherRemark === undefined) {
      setError("Please Enter Other Issue");

      return false;
    } else if (description === undefined) {
      setError("Please Enter Description");

      return false;
    } else {
      return true;
    }
  };

  const submit = (type) => {
    if (validate()) {
      raiseIssue.mutate();
    } else {
    }
  };
  return (
    <div className="commonFeature mt-[20px] ">
      {raiseIssue.isLoading && <SpinnerLoading />}

      <div className="bg-white rounded shadow p-2 card-timeline pb-4">
        <div className="md:p-2">
          <div className="py-2 text-center text-base font-medium leading-snug text-black">
            Our executive will get in touch with you within one business day.
            For anything urgent please get in touch with Teacher or Centre Head.
          </div>

          <form className="pt-2 space-y-4">
            {/* Radio Button List */}
            <fieldset className="px-4">
              {constants?.issueList.map((item, i) => (
                <div key={i} className="mb-2">
                  <FootprintInputRadio
                    className="mb-2 "
                    label={item}
                    value={item}
                    name="customRadio"
                    id={i}
                    onClick={(value) => {
                      SetIssue(value);
                      setError(undefined);
                    }}
                  />
                  {item}
                </div>
              ))}
            </fieldset>

            {/* Others Text Input */}
            {issue === "Others" && (
              <div>
                <FootprintInputText
                  type="text"
                  name="text"
                  id="otherIssue"
                  onChange={(value) => {
                    setOtherRemark(value);
                    setError(undefined);
                  }}
                />
              </div>
            )}

            {/* Description Input */}
            <label className="font-semibold text-dark ">Description</label>
            <div>
              <FootprintInputText
                type="text"
                name="text"
                id="writeIssue"
                placeholder="Write your issue here"
                onChange={(value) => {
                  setDescription(value);
                  setError(undefined);
                }}
              />
            </div>

            {/* Error Message */}
            {typeof error !== "undefined" && (
              <p className="text-red-600 text-sm">{error}</p>
            )}

            {/* Submit Button */}
            <div className="text-center">
              <FootprintInputButton onClick={submit} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RaiseTicket;
